
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { initClient } from '../../../api';
import { SurveyJsUiClient, SurveyResultView } from '../../backend/backendapi';
import { Results, VgtParameters } from './VgtRemoteManger';
import ResultsTable from './ResultsTable';

@Component({
  name: 'SurveyResultsCombinedComponent',
  components: {
    ResultsTable,
  },
})
export default class SurveyResultsCombinedComponent extends Vue {
  @Prop({ required: false })
  groupId!: string;

  private readonly api = initClient(SurveyJsUiClient);
  loadingFunction = this.loadResults.bind(this);

  private async loadResults(params: VgtParameters): Promise<Results<SurveyResultView>> {
    const data = await this.api.listResultCombined(this.groupId, params.pagination.page, params.pagination.perPage, params.filter, params.sort, params.search);
    return data as Results<SurveyResultView>;
  }
}
